document.addEventListener('DOMContentLoaded', async function(){
  let discountCode = 0;
  const old_cartDrawer__footer = document.querySelector('.cart-drawer__footer');
  const old_discount_html = document.querySelector('.discount_code_container');
  var popup_remove_btn_disc = document.querySelector('.input_coupon_container .model_footer .remove_discount_btn');
  // showDiscountCode();
  document.body.addEventListener('click', (e) => {
    const button = e.target.closest('.discount_code_container button');
    const targetClass = e.target.classList;
    if (button) {
      const discountCode = document.querySelector('.discount_code_container input').value.toLowerCase();
      button.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0650/7986/9645/files/Rolling_1x-0.8s-35px-35px.gif?v=1743569135" alt="Loading..." style="height: 20px; width: 20px;">`;
      if (button.classList.contains('apply_code')) {
        applyDiscount(discountCode);
      }
      if (button.classList.contains('remove_code')) {
        applyDiscount('remove');
      }
    }
    else if(targetClass.value == 'view_coupon_code'){
     document.querySelector('.input_coupon_container').classList.toggle('hidden');
    }
    else if(targetClass.value == 'copy_coupon_code'){
        var clipboardText = document.querySelector(".clipboard_text");
        // console.log('targetClass', e.target.attributes.code_title.value);
        navigator.clipboard.writeText(e.target.attributes.code_title.value);
        clipboardText.textContent = `${e.target.attributes.code_title.value} Copied`;
        clipboardText.classList.remove('hidden');
        setTimeout(function(){
          clipboardText.classList.add('hidden');
        }, 2000);
      }
    else if(targetClass.value == 'remove_discount_btn'){
      document.querySelector('.discount_code_container button').click();
      e.target.closest('.input_coupon_container').querySelector('.close_container').click();
    }
    else if(targetClass.value == 'close_container'){
      e.target.closest('.input_coupon_container').classList.add('hidden');
    }
  });
    
    async function applyDiscount(discountCode){
      if(discountCode == ""){
        const blankValue_error = document.querySelector('#CartDrawer .error_empty_discount');
        blankValue_error.classList.remove('hidden');
        setTimeout(function(){
          blankValue_error.classList.add('hidden');
          document.querySelector('.discount_code_container button').textContent = 'Use Coupon Code';
        }, 2000);
        return;
      }
      const requestOptions = {
        method: 'POST',
        headers:{
          'Content-Type':"Application/json"
        },
        body: JSON.stringify({
          discount: discountCode,
          sections: ['cart-drawer']
        })
      }
      const tgt_discount_res = await fetch(`/cart/update.js`, requestOptions);
      const cartResponse = await tgt_discount_res.json(); 
      //console.log('cartResponse', cartResponse.discount_codes[0]);

      if(!cartResponse.discount_codes[0].applicable && discountCode != 'remove') {
        const blankValue_error = document.querySelector('#CartDrawer .error_empty_discount');
        blankValue_error.classList.remove('hidden');
        setTimeout(function(){
          blankValue_error.classList.add('hidden');
          document.querySelector('.discount_code_container button').textContent = 'Use Coupon Code';
        }, 2000);
        return;
      }
      if (tgt_discount_res.ok ) {
          const parse = new DOMParser();
          const html = parse.parseFromString(cartResponse.sections['cart-drawer'], 'text/html');
          // updatePopup_btn();
          const oldCartDrawer = document.querySelector('cart-drawer');
          const newCartDrawer = html.querySelector('.shopify-section').querySelector('cart-drawer');
          oldCartDrawer.innerHTML = newCartDrawer.innerHTML;
      }
    }
});

// Blogs

document.querySelectorAll('.article-template .scroll-link').forEach(link => {
  link.addEventListener('click', function(e) {
    e.preventDefault();
    const targetId = this.getAttribute('href').slice(1);
    const target = document.getElementById(targetId);
    const headerOffset = 150;
    const elementPosition = target.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  });
});
// quantity button disable
  document.addEventListener("DOMContentLoaded", function () {
    const plusButtons = document.querySelectorAll('button[name="plus"]');

    plusButtons.forEach(function (plusButton) {
      plusButton.addEventListener('click', function () {
        const container = plusButton.closest('.quantity');
        const quantityInput = container?.querySelector('input.quantity__input');

        if (!quantityInput) return;

        // Delay reading value to let theme increment first
        setTimeout(() => {
          let qty = parseInt(quantityInput.value) || 1;

          // Show alert
         // alert('Plus button clicked! Quantity is now: ' + qty);

          // Disable the button at 10
          if (qty >= 10) {
            plusButton.disabled = true;
            plusButton.style.opacity = "0.5";
            plusButton.style.pointerEvents = "none";
          }
        }, 100);
      });

      // Optional: re-enable the plus button when quantity goes below 10
      const quantityInput = plusButton.closest('.quantity')?.querySelector('input.quantity__input');
      if (quantityInput) {
        quantityInput.addEventListener('input', function () {
          let qty = parseInt(this.value) || 1;
          if (qty < 10) {
            plusButton.disabled = false;
            plusButton.style.opacity = "1";
            plusButton.style.pointerEvents = "auto";
          }
        });
      }
    });
  });

// to disable buy it now
  // document.addEventListener("DOMContentLoaded", function () {
  //   const buyNowButton = document.getElementById("gokwik-buy-now");
  //   if (buyNowButton) {
  //     buyNowButton.addEventListener("click", function (event) {
  //       const quantityInput = document.querySelector('input.quantity__input');
  //       let qty = parseInt(quantityInput?.value) || 1;
  
  //       if (qty > 10) {
  //         alert("Only 10 items were added to your cart due to availability.");
  //         event.preventDefault(); // stops default
  //         event.stopImmediatePropagation(); // stops inline onclick (like GoKwik)
  //       }
  //     }, true); // Use capture phase to intercept before onClick
  //   }
  // });